// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"404":"abf94492","498":"1a1992ed","513":"2ff844b6","787":"30bb394f"}[chunkId] + ".chunk.js";
};